import React from "react";
import "../../Assets/SCSS/components/Pageheader.scss";

const sectionHeader = (props) => <p className="section-header-small">{props.header}</p>;

export default sectionHeader;
